import * as Types from "./types";

export const updateBusLocation = (data: any) => ({
  type: Types.UPDATE_BUS_LOCATION,
  payload: {
    data,
  },
});

export const updateEta = (data: any) => ({
  type: Types.UPDATE_ETA,
  payload: {
    data,
  },
});

export const updateLocationList = (data: any) => ({
  type: Types.UPDATE_LOCATION_LIST,
  payload: {
    data,
  },
});

export const getBusETA = (callback: () => void) => ({
  type: Types.GET_BUS_ETA,
  payload: {
    callback,
  },
});

export const getBusEtaSuccess = (data: any) => ({
  type: Types.GET_BUS_ETA_SUCCESS,
  payload: {
    data,
  },
});
